/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingoverrideplaceholder2Inputs */

const en_crosspostingoverrideplaceholder2 = /** @type {(inputs: Crosspostingoverrideplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave empty to use the caption above.`)
};

const de_crosspostingoverrideplaceholder2 = /** @type {(inputs: Crosspostingoverrideplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer lassen, um die obige Bildunterschrift zu verwenden.`)
};

/**
* | output |
* | --- |
* | "Leave empty to use the caption above." |
*
* @param {Crosspostingoverrideplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingoverrideplaceholder2 = /** @type {((inputs?: Crosspostingoverrideplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingoverrideplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingoverrideplaceholder2(inputs)
	return de_crosspostingoverrideplaceholder2(inputs)
});
export { crosspostingoverrideplaceholder2 as "crosspostingOverridePlaceholder" }